<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import Vue from "vue";
import "vue-select/dist/vue-select.css";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";
Vue.component("v-select", vSelect);
/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Reporte corte caja",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader},
  data() {
    return {
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {"x-token": this.$store.state.authfack.user.token},
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        totalArticulos: 0,
        total: "",
        state: true,
        id: 0,
        totalPendiente:0,
        totalPagado:0
      },
      fecha_inicial: "",
      rangode_fecha:"",
      corte:null,
      arraycorte: [],
      arraycortes: [],
      fecha_final:"",
      reporteya:false,
      no_venta:0,
      estadoCredito:null,
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
    };
  },
  mounted() {
    this.usuariosL();
  },
  updated() {
    //this.$refs["buttonImprimir"].click();
  },
  methods: {
    resetV(){
        this.reporteya=false;
        this.corte=null;
    },
    generar(){
    this.reporteya=true;
    this.detalle();
    },
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    async changeTypeDates(){
      await this.separarfechas()
    },
    separarfechas(){
      this.fecha_inicial=this.rangode_fecha[0]
      this.fecha_final=this.rangode_fecha[1]
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
      let me = this;
      let id=me.corte?me.corte.id:'';
      axios
          .get(
              process.env.VUE_APP_URL +
              "reportes/reporteCortec?search="+ id, 
              {
                headers: {"x-token": me.userT.token},
              }
          )
          .then((response) => {
            let detalleProducto = response.data.rows;
            me.detalleorden=detalleProducto
            me.formPro.totalArticulos =  response.data.rows.length;
          });
    },
    async selectcorte(valor) {
      this.arraycorte = [];
      for (var i = 0; i < this.arraycortes.length; i++) {
        const estado = this.arraycortes[i].usuario
            .toLowerCase()
            .includes(valor.toLowerCase());
        if (estado === true) {
          this.arraycorte.push(this.arraycortes[i]);
        } else {
          // console.log("nada")
        }
      }
    },
    async usuariosL() {
        this.arraycortes = [];
      try {
        const response = await axios.get(
            process.env.VUE_APP_URL + "users/get_usuarios",
            {
              headers: {"x-token": this.userT.token},
            }
        );
        this.arraycortes = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style>

</style>
<template>
  <Layout v-if="reporteya==true">
    <PageHeader :title="title" :items="items" class="d-print-none"/>
    <div class="row mt-4">
      <div class="col d-print-none">
        <b-button
                @click="resetV"
                class="ms-1"
                ><i  class="mdi mdi-arrow-left me-1"></i>REGRESAR</b-button
              >
      </div>
      <div class="col d-print-none">
        <div class="float-end">
          <a
              ref="buttonImprimir"
              href="javascript:window.print()"
              class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a
          >
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <div class="card-body">
            <div class="row">
                <div class="col-3"></div>
                <div class="col-6">
              <img
                  class="img-fluid float-right grises"
                  src="../../../../../src/assets/images/logoZonaR.png"
                  alt="Logo"
              />
              </div>
            </div>
            <br/>
            <div class="row" align="center">
              <div class="col" align="center">
                <h2 style="font-weight: bold;">Cortes de caja</h2>
              </div>
            </div>
            <div class="row" align="center">
              <div class="col" align="left">
                <h5>Cortes de caja: {{ formPro.totalArticulos }}</h5>
              </div>
              <div class="col" align="left" v-if="corte">
                <h5>Empleado: {{ corte.empleado.persona.nombre_persona +' '+ (corte.empleado.persona.apellido_persona?corte.empleado.persona.apellido_persona:'')}}</h5> 
              </div>
              <div class="col" align="left">
               <h5>{{ showHour(new Date()) }} </h5>
              </div>
            </div>
            <div>
              <table class="table table-sm table-bordered table-striped">
               
                <tr style=" padding: 0 !important; margin: 0 !important;">
                <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">No. Cierre</h5></th>
                  <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Usuario que realizo el cierre</h5></th>
                  <th style=" padding: 0 !important; margin: 0 !important;">
                    <h5 style="font-weight: bold;">Fecha de cierre</h5>
                  </th>
                  
                  <th style=" padding: 0 !important; margin: 0 !important;">
                    <h5 style="font-weight: bold;">Monto cierre</h5>
                  </th>
                </tr>
              
                <tbody>
                <tr v-for="(item, idx) in detalleorden" v-bind:key="idx" style=" padding: 0 !important; margin: 0 !important;">
                  
                    <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{ item.id }}
                    </h6>
                  </td> 
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{item.user.usuario+' | '+item.user.empleado.persona.nombre_persona+
                        " " +item.user.empleado.persona.apellido_persona  }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{showHour(item.fecha_hora)  }}
                    </h6>
                  </td>
                  
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6 align="right">
                      {{ money(item.fin_caja?item.fin_caja:0.00)  }}
                    </h6>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
  <Layout v-else>
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark"> 
          <div class="card-body">
            <br/>
            <div class="row" align="center">
              <div class="col" align="left">
                <h2>Reporte Corte de caja</h2>
              </div>
            </div>
            <div  class="row" align="center">
                <div class="col" align="left">
                    <form>
            <!-- Descripcion -->
            <div class="col-6">
                <div class="row">
                <label for="phone">Seleccione un usuario</label>
                </div>
                <div class="row">
                    <div class="col">
                    <v-select
                    style="--vs-dropdown-max-height: 200px;"
                                  v-model.trim="corte"
                                  :options="arraycorte"
                                  @search="selectcorte"
                                  placeholder="Buscar usuario..."
                                  label="usuario"
                              >
                              <template v-slot:option="options">
                              {{
                                options.usuario +
                                " | " +
                                options.empleado.persona.nombre_persona +
                                " " +
                                options.empleado.persona.apellido_persona
                              }}
                            </template>
                            <template
                              slot="selected-option"
                              slot-scope="option"
                            >
                              {{
                                option.usuario +
                                " | " +
                                option.empleado.persona.nombre_persona +
                                " " +
                                option.empleado.persona.apellido_persona
                              }}
                            </template>
                              </v-select>
                            </div>
                </div>      
            </div>
            <!-- Botones -->
            <div class="text-end pt-5 mt-3">
              <b-button
                @click="generar"
                variant="success"
                class="ms-1"
                >Generar Reporte</b-button
              >
            </div>
          </form>    
            </div>
        </div>
        </div>
    </div>
    </div>
    </div>
  </Layout>
</template>
<style>
.grises {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}

@media print {
  @page {
    margin: 0;
    size: auto;
  }
}
</style>
